package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** Nature d'un participant au combat. */
@Serializable
enum class CombatParticipantType { CHARACTER, ADVERSARY }

/**
 * Un participant au combat : un personnage joueur ([CombatParticipantType.CHARACTER])
 * ou un adversaire libre ([CombatParticipantType.ADVERSARY]).
 *
 * Sérialisé directement dans la colonne jsonb `game_table_combats.participants`
 * (même approche que [WhiteboardAction]). L'ordre = la position dans la liste.
 */
@Serializable
data class CombatParticipant(
    /** Identifiant stable du participant (suit la carte lors d'un réordonnancement). */
    @SerialName("id")
    val id: String,

    @SerialName("type")
    val type: CombatParticipantType,

    /** Nom affiché : nom du personnage ou de l'adversaire. */
    @SerialName("name")
    val name: String,

    /** userId du joueur propriétaire si [type] == CHARACTER, sinon null. */
    @SerialName("user_id")
    val userId: String? = null,

    /** id du personnage si [type] == CHARACTER, sinon null. */
    @SerialName("character_id")
    val characterId: String? = null
)
